import styles from 'css/src/components/app/audio-tab/PlayPauseButton.module.scss';

import React, { useCallback } from 'react';
import classNames from 'classnames';

import { usePlaybackFunctionality } from 'js/src/components/app/audio-tab/usePlaybackFunctionality';
import Button, { BUTTON_PADDING, BUTTON_WIDTHS } from 'js/src/components/common/ui/Button';
import type { PlayableAudio } from 'js/src/data/media';

type PlayPauseButtonPresentationProps = {
    media: PlayableAudio;
};

const PlayPauseButtonPresentation = ({ media }: PlayPauseButtonPresentationProps) => {
    const { togglePlayPause, isPlaying } = usePlaybackFunctionality(media);

    const onClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            togglePlayPause();
        },
        [togglePlayPause],
    );

    const iconName = isPlaying ? 'pause_circle' : 'play_circle';
    const buttonClassName = classNames(
        styles['play-pause-button'],
        'unselectable h-auto material-symbols-f1',
        { [styles['is-playing']]: isPlaying },
    );

    return (
        <Button
            className={buttonClassName}
            iconLeft={iconName}
            padding={BUTTON_PADDING.NONE}
            width={BUTTON_WIDTHS.NO_MIN_WIDTH}
            onClick={onClick}
            data-testid="play-pause-button"
        />
    );
};

const PlayPauseButtonMemoized = React.memo(PlayPauseButtonPresentation);
const PlayPauseButton = PlayPauseButtonMemoized;

export default PlayPauseButton;
